<button
  mat-raised-button
  color="primary"
  class="booking-cta"
  [ngClass]="{ 'booking-cta--modern': componentData?.layout === 'modern' }"
>
  {{ checkAvailability() | translate }}
</button>
